import * as platform from 'platform';

export const getFormattedDeviceDetails = () => {
  const userAgentDetails = navigator.userAgent;
  let deviceDetails = '';

  // device type
  let deviceType = '';
  if (userAgentDetails.match(/iPhone|iPod|iPad/i)) {
    // distinguish iPhone / iPod / iPad
    if (userAgentDetails.match(/iPhone/i)) {
      deviceType = 'iPhone';
    } else if (userAgentDetails.match(/iPod/i)) {
      deviceType = 'iPod';
    } else {
      deviceType = 'iPad';
    }
  } else if (userAgentDetails.match(/Android/i)) {
    deviceType = 'Android';
  } else if (userAgentDetails.match(/Mobile/i)) {
    deviceType = 'Mobile';
  } else if (userAgentDetails.match(/Windows/i)) {
    deviceType = 'Windows';
  } else if (userAgentDetails.match(/Macintosh/i)) {
    deviceType = 'Mac';
  } else if (userAgentDetails.match(/Linux/i)) {
    deviceType = 'Linux';
  }

  // Browser
  const browserName = platform.name || 'Unknown Browser';
  const browserVersion = platform.version || 'Unknown Browser Version';

  // OS
  let osName = '';
  let osVersion = platform?.os?.version;
  // Regular expressions for detecting different operating systems
  const windowsRegex = /Windows\sNT\s(\d+\.\d+)/i;
  const macRegex = /Macintosh;\sIntel\sMac\sOS\sX\s([\d_]+)/i;
  const linuxRegex = /Linux/i;
  const iOSRegex = /(iPhone|iPad|iPod).*\sOS\s([\d_]+)/i;
  const androidRegex = /Android\s([\d.]+)/i;
  if (userAgentDetails.match(windowsRegex)) {
    osName = 'Windows';
    osVersion = osVersion || userAgentDetails.match(windowsRegex)[1];
  } else if (userAgentDetails.match(macRegex)) {
    osName = 'macOS';
    osVersion = osVersion || userAgentDetails.match(macRegex)[1].replace(/_/g, '.');
  } else if (userAgentDetails.match(linuxRegex)) {
    osName = 'Linux';
  } else if (userAgentDetails.match(iOSRegex)) {
    osName = 'iOS';
    osVersion = osVersion || userAgentDetails.match(iOSRegex)[2].replace(/_/g, '.');
  } else if (userAgentDetails.match(androidRegex)) {
    osName = 'Android';
    osVersion = osVersion || userAgentDetails.match(androidRegex)[1];
  } else {
    osName = 'Unknown OS';
    osVersion = 'Unknown OS Version';
  }
  deviceDetails = `${deviceType}/${browserName}/${browserVersion}/${osName}/${osVersion}`;

  return deviceDetails;
};
